export default __webpack_public_path__ + "paddle_education_hover30e7fa.svg";